import { Navigate, Outlet } from 'react-router';
import { useAppSelector } from '@/store';
import { selectIsTenantUser } from '@/store/Auth/authSelectors';

/**
 * RequireTenantUser - Route guard component
 *
 * Protects routes that should only be accessible to Tenant Users (isSuper === false).
 * System admin users attempting to access protected routes will be redirected
 * to the system admin clients page (/os/clients).
 *
 * @example
 * // In router configuration
 * {
 *   path: '/app',
 *   element: <RequireTenantUser />,
 *   children: [
 *     // Tenant routes here
 *   ]
 * }
 */
export default function RequireTenantUser() {
  const isTenantUser = useAppSelector(selectIsTenantUser);

  if (!isTenantUser) {
    // Redirect system admin users to client management
    return <Navigate to='/os/clients' replace />;
  }

  return <Outlet />;
}
